import React, { useMemo, useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import BrandTeamProfileModal from "./BrandTeamProfileModal";
import { BrandTeam } from "../../types/model";

interface FeaturedBrandTeamCardProps {
	teamId?: string;
	imageUrl: string;
	points: number;
	teamName: string;
	description?: string;
	sportId?: string;
	seriesId?: string;
}

const FeaturedBrandTeamCard: React.FC<FeaturedBrandTeamCardProps> = ({
	teamId,
	imageUrl,
	points,
	teamName,
	description,
	sportId,
	seriesId,
}) => {
	const [showTeamModal, setShowTeamModal] = useState(false);
	const teamForModal = useMemo<BrandTeam>(
		() => ({
			_id: teamId,
			name: teamName || "",
			imageUrl,
		}),
		[teamId, teamName, imageUrl],
	);

	return (
		<Card className="w-100 bg-secondary py-4 px-3 rounded-3 text-light">
			<Card.Body>
				<Row className="d-flex align-items-center">
					<Col md={6} className="mb-4 mb-md-0">
						<Card.Img
							src={imageUrl}
							alt="Team Image"
							style={{
								maxHeight: "260px",
								width: "100%",
								objectFit: "contain",
							}}
						/>
					</Col>
					<Col md={6} className="d-flex flex-column justify-content-center">
						<Button
							variant="primary"
							className="mb-2 fw-bold rounded-pill px-3 py-0"
							style={{ width: "fit-content" }}
							size="sm"
						>
							{/* TOTAL POINTS: {points} */}
							FEATURED TEAM
						</Button>
						<Card.Text className="text-primary h5 fw-bold mb-1 mt-2 fs-3">
							{teamName}
						</Card.Text>
						<Card.Text className="text-light h4 fw-bold fs-2">
							{description || "NEW ROSTER AND DEVELOPMENT TEAM"}
						</Card.Text>
						{teamId && (
							<Button
								variant="outline-light"
								className="mt-3 fw-semibold"
								style={{ width: "fit-content" }}
								onClick={() => setShowTeamModal(true)}
							>
								View Team
							</Button>
						)}
					</Col>
				</Row>
			</Card.Body>
			<BrandTeamProfileModal
				show={showTeamModal}
				onHide={() => setShowTeamModal(false)}
				team={teamForModal}
				sportId={sportId}
				seriesId={seriesId}
			/>
		</Card>
	);
};

export default FeaturedBrandTeamCard;
